import React from 'react';
import {noop} from 'lodash/util';
import {isEqual} from 'lodash/lang';

import {getSchemes} from 'api/common';
import {SelectSearchAsyncBase} from 'components/Forms/FormBases';

const defaultProps = {
  name: 'scheme_id',
  placeholder: 'Select or Search by Name',
  cacheOptions: true,
  defaultOptions: true,
  filters: {},
  onChange: noop,
  getOptionLabel: (option) => option.scheme_name,
  getOptionValue: (option) => option.scheme_id,
};

class Component extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: props.selectedOption,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!isEqual(prevProps.selectedOption, this.props.selectedOption)) {
      this.setState({
        selectedOption: this.props.selectedOption,
      });
    }
  }

  loadOptions = async (inputValue) => {
    const {filters} = this.props;

    try {
      const {data} = await getSchemes({
        ...filters,
        search: inputValue,
        order: 'ASC',
        order_by: 'scheme_name',
      });

      return data;
    } catch (error) {
      return [];
    }
  };

  handleChange = (selectedOption) => {
    this.setState({selectedOption: selectedOption}, () => {
      this.props.onChange(selectedOption);
    });
  };

  render() {
    const {selectedOption} = this.state;
    const {filters, ...rest} = this.props;

    return (
      <SelectSearchAsyncBase
        {...rest}
        value={selectedOption}
        loadOptions={this.loadOptions}
        onChange={this.handleChange}
      />
    );
  }
}

Component.defaultProps = defaultProps;

export default Component;
